import React from 'react';

import Wallet from '../../images/Group 3@1.5x.svg';
import Button from '../helpers/Button';

const WalletCard = () => {
  return (
    <>
      <div className="block bg-white shadow-cfw w-full md:w-108 lg:w-120 py-6 rounded mt-10 hover:text-black">
        <div className="flex flex-wrap lg:flex-col items-center lg:justify-center">
          <div className="flex flex-wrap px-4 lg:px-6">
            <div className="flex flex-wrap justify-between">
              <div className="flex mr-8 lg:mr-16">
                <div className="h-6 lg:h-10 w-6 lg:w-10 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300">
                  <img
                    src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=256&q=80"
                    alt="Profile Pic"
                    className="inline-block h-full w-full object-cover"
                  />
                </div>
                <div className="ml-2 lg:ml-4">
                  <h4 className="text-sm md:text-base lg:text-lg font-bold">
                    Soya Bean | 15 Acres
                  </h4>
                  <p className="text-xs md:text-sm lg:text-base">Volta Region, Town, City</p>
                </div>
              </div>

              <div className="flex">
                <Button
                  name="Rollover"
                  className="bg-green-100 px-2 md:px-3 lg:px-5 py-1 lg:py-2 rounded text-cf-300 mr-2 text-xs md:text-sm lg:text-base"
                />

                <Button
                  name="Payout"
                  className="bg-cf-300 px-2 md:px-3 lg:px-5 py-1 lg:py-2 rounded text-white text-xs md:text-sm lg:text-base"
                />
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-between my-12">
              <div className="text-center mr-10 md:mr-16">
                <h5>GH 20,000</h5>
                <small>Farm Cost</small>
              </div>

              <div className="text-center mr-10 md:mr-16">
                <h5>GH 5,000</h5>
                <small>Amount used</small>
              </div>

              <div className="text-center">
                <h5>GH 15,000</h5>
                <small>Balance</small>
              </div>
            </div>

            <div className="flex flex-col block">
              <p className="hidden text-sm pt-3">
                Current Status:{' '}
                <span className="text-white bg-cf-300 px-2 py-1 rounded-sm">Farm Prep</span>
              </p>
              <div className="flex items-center w-80 md:w-90 lg:w-115 mt-2 border border-cf-300 rounded">
                <div className="w-8 bg-cf-300 px-2 py-3"></div>
                <p className="text-xs md:text-sm ml-6">5 months left</p>
              </div>
            </div>

            <div className="mt-2 flex flex-wrap justify-between text-xs md:text-sm">
              <p className="pr-1 md:pr-2 lg:pr-6 text-cf-300">Start</p>
              <p className="pr-1 md:pr-2 lg:pr-6">Land Preparation</p>
              <p className="pr-1 md:pr-2 lg:pr-6">Planting</p>
              <p className="pr-1 md:pr-2 lg:pr-6">Harvesting</p>
              <p className="pr-1 md:pr-2 lg:pr-6">Storage</p>
              <p>Market</p>
            </div>
          </div>

          <div>
            <div className="w-32 mx-auto block my-12">
              <img src={Wallet} alt="Wallet" className="inline-block h-full w-full object-cover" />
            </div>

            <div className="px-6 my-6">
              <div className="flex flex-wrap">
                <div className="h-8 md:h-16 w-8 md:w-16 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300">
                  <img
                    src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=256&q=80"
                    alt="Profile Pic"
                    className="inline-block h-full w-full object-cover"
                  />
                </div>
                <div className="ml-6">
                  <h4 className="text-lg font-bold border-b-2 border-green-600 pb-2">
                    Farm Manager latest update
                  </h4>
                  <span className="text-sm font-bold">Today, 24th May</span>
                  <p className="text-xs md:text-sm">
                    Growing conditions are currently
                    <br /> perfect. Some irrigation work is being
                    <br />
                    performed over the next week, but <br /> harvest schedule will not be affected..
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletCard;
